const CLASS_LOADING = 'loading';
const HTML_NODE = document.documentElement;

/**
 * Devuelve true si el elemento tiene la clase 'loading'
 * @param { Element } el
 * @returns { boolean }
 */
function getActiveLoading( el = HTML_NODE ){
  return el.classList.contains( CLASS_LOADING );
}

/**
 * Añade la clase 'loading' al elemento
 * @param { Element } el
 */
function setActiveLoading( el = HTML_NODE ){
  el.classList.add( CLASS_LOADING );
}

/**
 * Elimina la clase 'loading' del elemento
 * @param { Element } el
 */
function removeActiveLoading( el = HTML_NODE ){
  el.classList.remove( CLASS_LOADING );
}

/**
 * Alterna la clase 'loading' en el elemento
 * @param { Element } el
 */
function toogleActiveLoading( el = HTML_NODE ){
  getActiveLoading( el ) ? removeActiveLoading( el ) : setActiveLoading( el );
}

/**
 * Quita 'no-js' de <html> y, si <html> tiene 'loading' al inicio,
 * la elimina al completar la carga de la página.
 * @param { Object } options
 * @param { Element } options.target  Elemento objetivo para eliminar 'loading' (por defecto <html>)
 * @param { number }  options.delay   Retraso opcional en ms antes de quitar 'loading'
 */
function initLoading( { target = HTML_NODE , delay = 0 } = { } ){
  HTML_NODE.classList.remove( 'no-js' );

  const doRemove = ( ) => {
    if( getActiveLoading( target ) ){
      if( delay > 0 ){
        setTimeout( ( ) => removeActiveLoading( target ) , delay );
      } else {
        removeActiveLoading( target );
      }
    }
  };

  if( document.readyState === 'complete' ){
    doRemove( );
  } else {
    window.addEventListener( 'load' , doRemove , { once : true } );
  }
}

export { getActiveLoading , setActiveLoading , removeActiveLoading , toogleActiveLoading , initLoading };
